import React, {useEffect} from "react";
import Canvas from "../Canvas/";
import style from "./index.module.scss";
import ColorPicker from "../../ColorPicker/ColorPicker";
import Sidebar from "../../../components/SideBar/Sidebar";
import {useSelector, useDispatch} from "react-redux";
import VerticalAlignTopIcon from '@material-ui/icons/VerticalAlignTop';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import {Link} from 'react-router-dom'
import {ActionType} from '../../../redux/constants/existingCoords'
import Tooltip from '@material-ui/core/Tooltip';

const MapContainer = ({ match}) => {
  const opened = useSelector(state => state.colorpicker.opened)
  const dispatch = useDispatch()
  const isPreview = match?.params?.previewId;

  useEffect(()=>{
    dispatch({type: ActionType.SET_MARK_PREVIEW, payload: !!isPreview })
  }, [match])

  const handleScroll = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    })
  }

  const buttonScrollToTop = (
    <div className = {style.button} style = {{ left: '15px' }} onClick = {handleScroll} > 
      <VerticalAlignTopIcon />
    </div>
  )

  const buttonSwitchToMap  = isPreview ? 
  (
    <Link to = {`/${match.params.resort}/${match.params.resortId}`}>
      <Tooltip title = 'Switch to default map view'>
        <div className = {style.button} style = {{right: '15px' }} onClick = {handleScroll}>
          <SwapHorizIcon/>
        </div>
      </Tooltip>
     </Link>
  ) : null

  return (
    <section className={style.mapSection}>
      <Sidebar />
      {opened &&  <ColorPicker />}
      <div className={style.map}>
        {buttonScrollToTop}
        {buttonSwitchToMap}
        <Canvas />
      </div>
    </section>
  );
};

export default MapContainer
